// @ai-generated 2026-08-28T07:59:23+00:00 by matthias.gessinger@synqony.com using Claude Opus 5 (1M context)
import { ExportRunDetail } from '@Components/Documents';
import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import { useIsPortalSession } from '@Contexts/session';
import { type ApiDynamicExportRun, EnumDynamicExportDefinitionScope } from '@Model';
import { Button, useOnTheFlyModal } from '@synqo/frontend-component-library';
import { IconFileCode } from '@tabler/icons-react';
import { useCallback } from 'react';
import { FrameEditDynamicExportDefinition } from './FrameExportDefinition';

/**
 * Opens one export run's detail panel, for use as a table's `onSelect`.
 *
 * A failed run is almost always a script the user has to fix, so the panel carries the definition it
 * ran with as its one action — reached in a second, stacked panel instead of a route, so the run and
 * the script that produced it stay on screen together. Only a definition of the mandant opens: a system
 * standard is out of a mandant's reach, and a portal customer does not edit the mandant's scripts.
 */
export function useExportRunDetailModal() {
    const { openOnTheFlyModal, closeOnTheFlyModals } = useOnTheFlyModal();
    const hasPermission = useHasPermission();
    const isPortal = useIsPortalSession();
    const canReadDefinition = !isPortal && hasPermission(Permission.DocumentsDynamicExportDefinitionRead);

    const openDefinition = useCallback(
        (definitionId: string) => {
            let modalId = '';
            modalId = openOnTheFlyModal({
                label: 'Exportdefinition',
                child: (
                    <FrameEditDynamicExportDefinition
                        primaryKey={definitionId}
                        embedded
                        events={{
                            onBack: () => closeOnTheFlyModals(modalId),
                            onClose: () => closeOnTheFlyModals(modalId),
                        }}
                    />
                ),
            });
        },
        [openOnTheFlyModal, closeOnTheFlyModals],
    );

    return useCallback(
        (run: ApiDynamicExportRun) => {
            openOnTheFlyModal({
                label: `Export ${run.number}`,
                header: {
                    title: `Export ${run.number}`,
                    toolbarActions:
                        canReadDefinition &&
                        run.export_definition_id &&
                        run.definition_scope === EnumDynamicExportDefinitionScope.Mandant ? (
                            <Button
                                appearance="transparent"
                                size="xs"
                                onClick={() => openDefinition(run.export_definition_id)}
                                label="Definition öffnen"
                            >
                                <IconFileCode size={16} />
                                &nbsp;Definition öffnen
                            </Button>
                        ) : undefined,
                },
                child: <ExportRunDetail run={run} />,
            });
            return true;
        },
        [openOnTheFlyModal, canReadDefinition, openDefinition],
    );
}
